import script from "./ConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmModal.vue?vue&type=style&index=0&id=79c18c29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c18c29"]])

export default __exports__